export default "__VITE_ASSET__SKbtdAxv__"